import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// CREATE GRATITUDE JOURNAL
export const createGratitudeJournal = async (user, journal) => {
  try {
    const payload = {
      user_id: user?.id,
      journal: journal
    };

    const response = await axios.post(
      `${API_BASE_URL}/gratitude-journal`,
      payload
    );

    return response;
  } catch (error) {
    console.error("Error creating gratitude journal:", error);
    return null;
  }
};

// GET GRATITUDE JOURNALS
export const getGratitudeJournals = async (userId, filter = "today") => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/gratitude-journal/${userId}?filter=${filter}`
    );

    return response;
  } catch (error) {
    console.error("Error fetching gratitude journals:", error);
    return null;
  }
};


export const updateGratitudeJournal = async (userId, journalId, journal) => {
  try {
    return await axios.put(
      `${API_BASE_URL}/gratitude-journal/${userId}/${journalId}`,
      { journal }
    );
  } catch (error) {
    console.error("Error updating gratitude journal:", error);
    return null;
  }
};


export const deleteGratitudeJournal = async (userId, journalId) => {
  try {
    return await axios.delete(
      `${API_BASE_URL}/gratitude-journal/${userId}/${journalId}`
    );
  } catch (error) {
    console.error("Error deleting gratitude journal:", error);
    return null;
  }
};